/**
 * Truncate <tt>str</tt>
 * @param {string} str - The string to truncate
 * @param {Object} [params] - Function params
 * @param {number} params.limit - Upper position to be removed of the string
 * @param {boolean} params.dots - flag to add three dots at the end of the string
 * @returns {string}
 * */
export default function truncate(str, {limit = 8, dots = false} = {}) {
    if (str && str.length > limit) {
        return `${str.slice(0, limit)}${dots ? '…' : ''}`;
    }
    return str;
}
